import { Module } from "vuex";
import { RootState } from "..";
import { APP_ACTIONS } from "./app.actions";
import { APP_MUTATIONS } from "./app.mutations";
import { APP_GETTERS } from "./app.getters";
import { ToastModel } from "@/interfaces/app/toast-model";

export interface AppState {
  toastModal: ToastModel,
  sidebarStatus: boolean,
  chat: boolean
}

const INITIAL_STATE: AppState = {
  toastModal: {
    status: false,
    message: "",
    type: "info"
  },

  sidebarStatus: false,

  chat: false
};

export const app: Module<AppState, RootState> = {
  actions: APP_ACTIONS,
  getters: APP_GETTERS,
  mutations: APP_MUTATIONS,
  state: INITIAL_STATE,
  namespaced: true,
};
